module.exports = __webpack_public_path__ + "static/media/view class wise.850735cb.svg";